import SV from 'server-vars';

const SELLER_APPLICATION_BUSINESS_DETAILS = 'Seller-Application-Business-Details';

const sellerApplicationBusinessDetailsAbTest = SV.get(
    'abTestsV2.' + SELLER_APPLICATION_BUSINESS_DETAILS
)?.variant;
const isVariantSellerBusinessDetailsAbTest = sellerApplicationBusinessDetailsAbTest === 'variant';

const shouldShowStateField = (country: string): boolean => !!(country && country === 'US');

export {
    SELLER_APPLICATION_BUSINESS_DETAILS,
    sellerApplicationBusinessDetailsAbTest,
    isVariantSellerBusinessDetailsAbTest,
    shouldShowStateField,
};
